import types from './Types';
import { logAvailability } from './Analytics';

export const fetchInventoryMsg = (URL) => {
    return (dispatch) => {
        dispatch({ type: types.FETCH_INVENTORY_MSG_REQUEST });

        return fetch(URL)
                .then(response => {
                    return response.text();
                })
                .then(response => {
                    let jsonResponse;
                    try {
                        jsonResponse = JSON.parse(response);
                    } catch (e) {
                        throw new Error(response);
                    }
                    if (jsonResponse.success && jsonResponse.message) {
                        dispatch({ type: types.FETCH_INVENTORY_MSG_SUCCESS, inventoryMsg: jsonResponse.message });

                        // analytics
                        dispatch(logAvailability(jsonResponse.message));
                    } else {
                        dispatch({ type: types.FETCH_INVENTORY_MSG_FAIL, inventoryError: e.message });
                    }
                })
                .catch(e => {
                    dispatch({ type: types.FETCH_INVENTORY_MSG_FAIL, inventoryError: e.message });
                });
    }
};
